import webuiPopover from "webui-popover";

export default class Preinscription {

    constructor() {
        Preinscription.blocPreinscription();
    }

    static blocPreinscription() {

        let insults = "10-4|304|404|40-watt club|5150|5ux0r|74|a|abbreviated piece of nothing|accident|acid freak|acid head|a face that only a mother could love|" +
            "a few cans short of a six pack|ahole|airhead|almy|Amazon|anal retentive|ankle biter|anorak|antwacky|arse|arsehole|arsewipe|as much use as a chocolate fireguard|" +
            "as much use as a chocolate teapot|as much use as a handbrake on a canoe|a snore|ass|asscan|ass-can|assclown|ass clown|ass-end of space|ass face|" +
            "ass fuck|assful|asshole|assholery|ass-kisser|ass monkey|ass munch|ass up|ass-wipe|ate up|ate up with the dumb ass|attention whore|b|b4k4|baby|" +
            "back 40|bad-ass|bad guy|bad news|bad seed|badussy|bag|bag bitch|bagger|bag of shit|bait|bait out|bamma|bananas|bang|banged up|bang hole|barf|" +
            "Barney|basket case|bastard|bat fastard|bat-shit crazy|batty|beast|beastly|beat|beater|beat-up|beat with the ugly stick|Becky|beep face|beeyatch|" +
            "beyotch|BFD|BFE|B.G.|bia|biatch|bible thumper|biddy|big deal|big whoop|billy|bimbo|bint|biotch|bird|bird-brain|bisnitch|bisnotch|bitch|" +
            "bitch ass|bite|bite it|bite me|bite (one's) ass|bite the pillow|bizatch|biznatch|biznitch|bizo|bizzo|blabbermouth|blah|blank-stick|blech|" +
            "blivet|blivit|bloatware|blonde|blood|blow|blow chunks|blow me|bludger|blue-hair|bobo|boed|bof|BOFH|bogus|bollocks|bomb|bonehead|boner|bonkers|" +
            "boob|booby|booey|BOOF|boojee|bookworm|boondocks|boonies, the|boop, leave a message|booshi|boot|boot-leg|bootlicker|boots|booty|bore shitless|" +
            "bore stiff|bottom feeder|bourgee|box of rocks|bozo|brainiac|breezy|brew|brick|bridezilla|broke|brown-noser|brutal|brutes|buck|buckled|buckshot|" +
            "budissy|buff|buffalo|buffoon|bugaboo|bugger|bugly|bullshit|bull shit|bull stuff|bum|bum around|Bumblefuck|bumfuck|Bum Fuck, Egypt|bumlick|bump|" +
            "bumpkin|bum rap|bun|bunk|buns|'burbs, the|burned|burned out|burner|burnout|burn-out|bush league|bushpig|bust|busted|busted-ass|butt|butterface|" +
            "butter face|butterhead|butters|Butt-Fuck, Egypt|Butt-Fucking, Egypt|butt-fugly|butt-head|butt hugger|butt-munch|butt plug|butt ugly|Cairo|cake|" +
            "call girl|camper|candy-ass|candy-assed|Captain Whiskey Dick|cathouse|celebutard|certifiable|chach|chank|chap|cheese nug|cherries|chew|chicken|" +
            "chicken head|chicken hoe|chicken-shit|chillbilly|chincy|chintzy|choad|chochie|chode|chode monster|chode muffin|chooch|choot|chowder head|chronic lag|chucklehead|chump|CI|clean|clod|clone|cock|cockbag|cock-juggling thunder cunt|cock knocker|cock-roach|cocksucker|codger|coke whore|commie|cool guy McGee|coot|cooter|cottage|couch potato|cougar|cow|coxo|coyote|coyote ugly|crackass|crack baby|cracked out|crack head|cra-cra|crank|crank whore|crap|crap-fest|crappy|craptacular|craptastic|cray|cray-cray|crazier than a run-over dog|crazier than a shit-house rat|craziness|crazy-pants|creep|creeper|creepy|cretin|crew|" +
            "crim|Criminole|crockadillapig|cronk|crotch fruit|crumb bum|crummy|crunchy|crunk|cuckoo|cuckoo for Cocoa Puffs|culture vulture|cum dumpster|cunt|cuntbag|cunt grabber|cunt head|cunt hole|cunt licker|cuntosaurus|cuntsicle|'c' word|damaged goods|DAN|date|d bag|DBI|DD|dead|dead rubber|Debbie Downer|Deliveranceville|derf|desk monkey|devil, the|dick|dick face|dickhead|dick lick|dick smack|dick sucker|dick wad|dildo|dill hole|dill weed|dim|dimp|dimwit|ding-a-ling|dingbat|ding-head|dingus|dink|dipshit|dipstick|dirt|dirtwad|dirty|ditz|div|DNB|dodgy|dodo|doe|dog|dog-faced|doiche|doink|dolt|do my head|dong|donkey-faced|doofus|doorknocker|doosh|dope|dope fiend|" +
            "dope monger|doper|dope whore|dork|dork breath|dork slap|dosser|do the pooch|double-bagger|double R|doubly purdy|douche|douche b|douche bag|douche bagel|douche canoe|douche dick|douche nozzle|doucher|doush|DP|drag|drainer|drongo|drop dead|drop in the bucket|dropkick|druggie|duck|Dullsville|dumbass|dumb-ass|dumb bunny|dumbfuck|dumb-fuck|dumb-head|dump|dump truck|durge|dweeb|EAD|East Bumblefuck|East Butt-fuck|East Nowhere|eat a bitch|eat a dick|eat it|eat me|eat my shorts|eat shit|eat shit and die|eejit|eff off|egghead|Egypt|ent|escort|e-tard|e-tarded|eye broccoli|face like a workman's bench|fag|faggot|fail|fake|false|fanboi|fanboy|" +
            "fanny|farging icehole|far out|fart|fart face|fartknocker|fart-knocker|fatal attraction|fat cat|fecker|fence|feral|fidiot|FILF|fish|flid|flipper|FLK|floozie|floozy|fluck a duck|fluff|flyover country|FOAD|focker|fool|FOP|freak|freaking|freaky|freaky-deaky|fried|FRO|from hunger|fruitcake|FU|FUBAR|fubugly|fuck|fuck-bitch|fuckbunny|fucked up|fucker|fuck face|fuckhead|fuck head|fucking|fuck nigga|fucknut|fuck nut|fucko|fuck off|fuck (one's self)|fucksqueek|fuck stain|fuck stick|fucktard|fuck up|fuckward|fuckwit|fuckwitt|fuck yo mama|fucunt|fug|fugazi|fugly|FUGMO|funk|funkdafied|funky|funky monkey|fun sponge|futhermucker|g|gang banger|gangstar|garden tool|gay|geek|geek chic|geek monster|get a life|get bent|get stuffed|get to fuck|GFE|GFY|GFYS|" +
            "ghettified|ghetto|ghetto bird|gigolo|gimp|girlfriend experience|girly-girl|git|give the skeeves|give the wiggins|gnarly|gobshite|go fly a kite|go fuck a|go fuck (one's self)|go fuck on (one's self)|go jerk yourself|go make me a sandwich|gomer|goober|gooberhead|goocher|good from afar, far from good|good from afar; far from good|good ol' boy|good old boy|goon|go pear-shaped|gorby|gorp|gotard|go to hell|granola|grasshopper|griefer|grit|gritter|grizzly chicken|grody|grommet|gronk|grub|Guam|gumby|gump|gutter punk|gutter whore|hack|hacked up|hackish|hairbag|half-ass|hard on the eyes|has-been|hater|have a face fit for radio|have a face like a bag of hammers|have a screw loose|" +
            "hayseed|head|head case|heinous|hellacious|herb|hick|hillbilly|himbo|hit|hit up from the chin up|hit with an ugly stick|ho|hockey whore|hodger|hoe|hoebag|hoe stroll|hogbeast|hogley|hog-wild|hole digger|home boy|Homer|homo thug|ho-nasty|hooch|hoochie|hood|hook|hooked|hooker|hoopty|hoover|hop-head|horndog|horse shit|horse's petute|hose beast|hoser|hoss|hotbox|hugly|humdrum|hump|hurt|hussy|huzzie|hype|hyphy|icky|ID10T|ID-10-T|idjet|ijit|in (one's) face|insane in the membrane|jabroni|jabronie|jack|jackass|jacked up|jackhole|jack hole|jack off|jackpine savage|jackwagon|jack wagon|jag-off|jag-wagon|jank|JB|j-cat|jecka|Jenny McCarthy|jerk|jerk-ass|jerk-face|jerk-nut|jerk off|jerkwad|jobber|John|jork|jughead|jumpoff|jump the shark|junkie|junky|Keep digging, Watson.|" +
            "kicking|kid|kiddie|kiddie stroll|kife|kiss (one's) ass|klink|knob|knobhead|know-it-all|knuckle dragger|knucklehead|knuckle-nuts|kook|kooky|kutta|lame|lame-ass|lame-o|lame sauce|larry|lazy dog|leafy|leebo|lemon|lencho|libtard|lick it|lick my froth|lick my scroat|lick (one's) clit|like ass|like ass pie|like death warmed over|like watching paint dry|limpdick|limp dick|llama|LMP|loaf|loaf about|loaf around|loc|LOL|LOLITA|loon|loony|looper|loopy|loose|lot lizard|loud|louse|lovely|lunchin'|lunkhead|lurker|mack daddy|mad|madame|mad as a hatter|madcap|mad hatter|mad whack|mafugly|mahfugly|mangy|mank|man-slut|manster|manwhore|Mary|melon|Melv|Melvin|merked|mess|messed|messed up|Mickey Mouse|middle of nowhere, the|MILF|mimbo|minger|mob|mofo|mo fo|mofugly|mole|moll|momo|" +
            "Mona Bushpig|mondo bizarro|monet|monster|moran|more cuckoo than a clock|more cuckoo than a clock factory|moron|mothafucka|mother fucker|mother trucker|motor-mouth|mouth breather|mud duck|mudpout|mugly|mule head|munchkin|mundane|muppet|mushroom|MWF|naff|nappy|nas|nastafied|nasty|NAUF|neck|neckbeard|need a check up from the neck up|nerd|nerdcore|nerdery|nerdgasm|nerdulent|nerdy|newb|newbie|nightmare|nimrod|nincompoop|nitwit|NMS|no biggie|noid|non-linear|noob face|nope|not mind safe|nucking futs|nugget|numb nut|numb-nuts|numbskull|nummah|numpt|numptie|numpty|nut|nut job|nuts|nutso|nutter|nuttso|nutty|obeast|odd duck|off (one's) box|off (one's) nut|off (one's) rocker|off the deep end|off the wall|OG|old bag|old fart|Old Man Jenkins|old timer|Omega Mu|" +
            "on crack|one fry short of a Happy Meal|(one's) face|(one's) highness|OP|otaku|out of hand|out of (one's) mind|out of the box|out there|out to lunch|over the hill|oxygen thief|pants|pap|paper bag trick|pass around pussy|pay lay|Pebbles|pencildick|penis-face|perma-fried|perp|person of interest|perv|perve|Peter|pickle fucker|pid|piece|piece of shit|pieon|pig|pigeon|PIK|piker|pill|pill popper|pimp|pinhead|pish|piss|piss-ant|pisshead|piss-poor|PITA|pits, the|plank|player hate|player hater|plonker|Poindexter|poon|poophead|poop on you, then.|poo-poo on you|poopy|pop|popcorn hoe|popper|pop slag|poseur|postal|potato quality|pound sand|prannock|prick tease|pro|prole|proof or STFU|propellerhead|prostitot|psycho|psycho-bitch|psychonaut|puck bunny|pud-whack|" +
            "pud whacker|pug fugly|puke|pukoid|punk|punter|pussy|pussy-hole|put that in (one's) pipe and smoke it|putz|quack|quart|Quayle|queaf|queef|ram|rassclat|rat|raunch|raunchy|redic|redneck|reechy|reject|religitard|REMF|re-re|rest and vest|retaardvark|retard|retarded|rhino|ridonkulous|rim|rinky-dink|ripper|robot|rot in hell|r-tard|RUB|rubbish|rug-rat|runner|run with the world|sack of shit|sad|Sally|salty|santorum|sausage|sausage fest|sausage jockey|sausage party|scag|scarred|scary|schlong|schlub|schmuck|screw|screw off|screw the badger|screwy|scrote|scrub|scrubb|scud|scum|scumbag|scum-bucket|scum of the earth|sea donkey|sea hag|seven thirty|shawty|sheep|sheisty|sherlock|shiksa|shill|shit|shit-bag|shit-bat crazy|shitface|shit fucker|shithead|shit out of luck|" +
            "shits, the|shit stirrer|shitty|shmuck|shorty|shove it|shove it up (one's) ass|shovel-face|shove off|sick|sick fuck|skag|skank|skeeve|skeevy|skeevy ho|skeezy|skeezy ho|sketchy|sketel|skid|sko|slackass|slack-jaw|slack-jawed|slack-jawed lackey|slag|sleazeball|sleep around|slimebag|slimeball|slitch|slob|slore|slub|slumpbuster|slump buster|slunt|slut|slutty|smacktard|small potatoes|smoke crack|smoke (one's) johnson|smoke on that|SNAF|snake|snapperhead|snatch|snitch|snooze|so-and-so|sod|SOL|son of a gun|sons of bitches|sorostitute|spastic|spaz|sped|speed freak|spich|spork|square|stank|STFU|stick|sticks, the|stiff|stig|stink|stinkie cheese|stoner|stooge|stoopid|straight|strange duck|strill|stroll|stu|stuff it|stuffy|stupid|suck|suck a bag of dicks|suck a fat baby's dick|" +
            "sucka-fu chicken-head|suck at|suck it|suck (one's) dick|suck on that|suck rocks|suck shit|suck so hard|suck that|suck the big one|suck up|sucky|sugar honey ice tea|sux|swamp donkey|swede|sweetie|sword fight|tacky|take a hike|tard|tart|tart monkey|tattle tail|tattle tale|tea bag|technotard|tech weenie|television bum|ten pounds of shit in a five-pound bag|terribad|thanks for nothing|throwed|throwed off|thug|tight-ass|tired|toc|toe|toe up|toilet|toker|tool|toolbox|tore back|tore up|tore up from the floor up|tosser|tough shit|tough titty|tow up|trailer trash|trainwreck|train wreck|tramp|trash|trench coat|trendy loke|trick|trif|trifling|trippy|troglodyte|troll|TUFU|turd|twat|tweaker|tweeker|tween|twerp|twinkie|twisted|twit|twittlefuck|two-bagger|two-bit|two cans short of a six pack|" +
            "two o'clock beauty queen|ugly|ugly as sin|ugly stick|unbelievabubble|uncle fucker|uncool|unholy|up (one's) nose with a rubber hose|Upper Rubber Boot|up yours|USer|vag|varmint|village bicycle, the|viper|vulture capitalist|wackadoodle|wacked|wacked out|wain|wally|wank|wanker|Wanker Town, USA|wanksta|WASPy|wassock|waste|wastoid|wazzock|weak|weenie|weirdo|welch|welfare|wet|wet blanket|whack|whacked|whacked out|whack job|whatever|whipper-snapper|Whiskey Tango|white bread|white trash|whore|whorehouse|whoremonkey|wideo|wigged out|window licker|Windoze|winner|wipper-snapper|wise guy|woofer|word up to your mother|worked|working girl|write-only code|wuppie|wuss|Xbox|xippie|yahoo|yak|yokel|yo momma|younger model|youngin'|your mamma|your mom|your mom was good last night|yuck|yucky|yutz|zany" +
            "Quadrizomique|Baltringue|Crétin|Abruti|Connard|Fils De Pute|Couillon|Tête De Noeud|Enfoiré|Empaffé|Gros" +
            " Naze|Grosse Truie Violette|Tafiole|Tarlouze|Loboto|Mange Merde|Suce Boules|Enculé|Tête De Chibre|Bite" +
            " Molle|Face De Cul|Sale Pute|Pétasse|Raclure De Chiotte|Pourriture|Tête De" +
            " Con|Con|Radasse|Pouffiasse|Faquin|Débile|Geudin|Crétin Des Alpes|Chinois De Paravent|Fils De Con|Fesse" +
            " D'huitre|Pendard|Pétassoïde Conassiforme|Couille De Moineau|Conchieur|Tartignole|Foutriquet|Décérébré|Résidu" +
            " De Fausse Couche|Pine D'huitre|Pinailleur|Connasse|Boudin|Avorton|Paltoquet|Fiente|étron|Merde" +
            " Molle|Minable|Minus|Moins Que Rien|Va Nu Pieds|Clitosaure De Brontoris|Infame Raie De" +
            " Cul|Dugland|Baraki|Enculeur De Mouches|Grosse Merde Puante|Pute Borgne|Chiure De Pigeon|Petite" +
            " Merde|Gougnafier|Merdasse|Bachibouzouk|Ducon|Hurluberlu|Salope|Zonard|Bubon Puant|Chien Galeux|Ordure" +
            " Purulente|Jobastre|Jobard|Barjot|Putréfaction|Suintance|Kroumir|Wisigoth|Lèche-cul|Putain|Zazou|Bougre " +
            "De Conne|Yéti Baveux|Fion|Couille Molle|Moudlabite|Cinglé|Frapadingue|Zéro|Pouacre|Pouacreux|Piètre|Peine à " +
            "Jouir|Microcéphale|Enfant De Salauds|Face De Pet|Grognasse|Raclure De Bidet|Chien Maudit|Crétin Goîtreux|Balai De " +
            "Chiottes|Mérule|Gogol|Pétochard|Planqué|Jaune|Fainéant|Faignasse|Branleur|Branlotin|Merdophile|Nain De " +
            "Jardin|Nunuche|Clown|Cocu|Caribou|Saligaud|Nounouille|Coprophage|Cornichon|Salaud|Salopiaud|Naze|Malotru|Sodomite|Pédale|Tantouze|Cave|Loquedu|Fripouille|Canaille|Maraud|Mécréant|Chien " +
            "D'infidèle|Morue|Blaireau|Bande Mou|Sombre Conne|Psychorigide|Gros Con|Vieux Con|Sombre Crétin|Nigaud|Catin|Andouille|Conne|Scaphandrier " +
            "D'eau De Vaiselle|Sous Merde|Fonctionnaire|Oiseau De Mauvaise Augure|Fesses Molles|Hérétique|Furoncle|Panaris|Corniaud|Vieille " +
            "Taupe|Zigomar|Caprinophile|Anachorète|Vieux Tableau|Thon|Vieille Poule|Cornard|Concombre|Ivrogne|Carburateur à Beaujolais|Imbibé|Détritus|Merlan " +
            "Frit|Tête à Claques|Ramassi De Chiure De Moineau|Vieux Chnoque|Hostie D'épais|Cuistre|Bougre De Congre|Dypterosodomite|Morveux|Pisse " +
            "Froid|Rambo De Pacotille|Betterave|Poireau|Trou Du Cul|Tronche De Cake|Trou De Balle|Schtroumph à Lunettes|Pipistrelle Puante|Erreur " +
            "Génétique Vaaa !!|Mickey|Patate|Fils De Keuf|Chancreux !|Gomorrhéen !|Tête D'ampoule|Idiot|Cloporte|Cancrelat|Gibier De Potence|Chacal " +
            "Puant|Don Juan De Pissotière|Obsédé|Imbécile|Taré|Pov Tache|Charogne|Narvalo|Morille|Tabernacle|Sac à Merde|Manche à Couille|Flaque De " +
            "Pus|Maquereau|Couille De Loup|Sac à Foutre|Brêle|Anus De Poulpe|Pisseuse|Chiassard|Sacripan|Tapette|Caillera|Fumier|Bouffon|Ectoplasme|Malpropre|Truand|Cervelle D'huitre|Petzouille|Crétin Des " +
            "Iles|Crotte De Moineau|Face De Rat|Pet De Moule|Mou Du Bulbe|Playboy De Superette|Spermatozoide Avarié|Loutre Analphabète|Pot " +
            "D'chambre|Nécrophile|Ecervelé|Roulure|Mont De Brin|Faraud|Boule De Pus|Branquignole|Pauvre Con|Fini à L'urine|Vérole|Pignouf|Banane|Pervers|Gras " +
            "Du Bide|Mou Du Gland|Couille De Tétard|Mou Du Genou|Moule A Gauffre|Pygocéphale|Nul|Boulet|Spermiducte|Dégénéré Du " +
            "Bulbe|Glandus|Schnock|Poltron|Tonnerre De Brest|Gugus|Boursemolle|Morbleu|Bougre D'ane|Bougre D'imbecile|Grand Cornichon|Sac à " +
            "Vin|Crassard|Sinistrose Ambulante|Erreur De La Nature|Résidus De Partouze|Margoulin|Cryptorchide|Peigne-cul|Peau De Vache|Crâne " +
            "D'obus|Bourique|Vieux Fossile|Crevard|Asticot|Crapaud De Pissotière|Bandit Calabrais|Décamerde|Plouc|Bouseux|Péquenot|Pimbêche|Gueux|Traîne " +
            "Savate|Pute|Morpion|Pisse-vinaigre|Dugenou|Mononeuronal|Salopard|Trumeaux|Quiche|Boloss|Vieux Tromblon|Vilain Comme Une Couvée De " +
            "Singe|Degueulasse|Chienne|Outre à Pisse|Marin D'eau Douce|Emplâtre|Sauvage|Aztèque|Grenouille De Bénitier|Marchand De " +
            "Tapis|Iconoclaste|Chenapan|Zoulou|Doryphore|Zouave|Pirate|Garage A Bite|Bouche à Pipe|Couard|Necropédophile|Paumé|Scelerat|Bigleux|Boutonneux|Molasson|Pompe " +
            "A Merde|Impuissant|Eunuque|Dégueulis|Vautour|Globicéphale|Tas De Saindoux|Analphabète|Sac à Viande|Niguedouille|Empoté|Clodo|Lavedu|Usurpateur|Langue " +
            "De Pute|Crevure|Pousse Mégot|Faschiste|Tabarnak|Nazillon|Félon|Nique Ta Mère|Vandale|Enflure|Mouton De Panurge|Pue Du " +
            "Bec|éspèce Di Counasse|Calculatrice|Cloaque|Gourgandine|Pécore|Outrecuidant|Chiennasse|Crasspouillard!|Souillon|Traînée|Laideron|Cageot|Neuneu|Judas|Béotien|Dégénéré " +
            "Chromozomique|Gangrène|Palsembleu|Bassine A Foutre|Aspirateur A Muscadet|Chafouin|E|Gland|Rougne|Troubignole|âne|Schpountz|Sybarite|Satrape|Fiote|Guignol|Tanche|Merde|Poire|Bête|Putassière|Gourdasse|Batard|Méchant.|Chieur|Morfale|Goinfre|Gueulard|Gros " +
            "Lard|Vorace|Goulu|Fricoteur|Glandeur|Bleubite|Gonzesse|Vioque|Pecore|Burne|Carne|Pleutre|Paysan|Kéké|Nanar|Sabraque|Tricard|Queutard|Fada|Larve|Porc|Pouilleux|Arsouille|épave|Sot|Merdaillon|Branque|Vermine|Chien|Lopette|Mortecouille|Saltinbanque|Clampin|Roquet|Chameau|Veule|Chacal|Tocard|Renégat|Fourbe|Jean-foutre|Scatophile|Mongol|Goujat|Gommeux|Stupide|Atardé|Manant|Leche-boules|Nabot|Motherfucker|Dicksucker|Phlegmon|Punaise|Gringalet|Frappe|Foireux|Freluquet|Maquerelle|Pignolo|Pigeon|Tétard|Assisté|Trainée|Garce|Poufieux|Calice|Tacheron|Piqueniquedouille|Butor|Nez De Boeuf|Fripon|Vilain|Voleur|Vaurien|Ganache|Tromblon|Filou|Zoboromok|Has-been|Boursouflure|Polisson|Crasseux|Crasseuse|Frigide|Zozo|Boubourse|Crapule|Vicelard|Pintade|Four à Merde|Paillasse à Maquereaux|Gueule De Fion|Fouille Merde|Faux Jeton|Histrion|Bégueule|Bolchévique|Chaoui|Olibrius|Parasite|Sagouin|Pissure|Godiche|Saloperie|Pine D'ours|Saperlotte|Cochon|Grue|Rouge|Cul Terreux|Dépravé|Homoncule|Parvenu|Cloche|Grand Dépandeur D'andouilles|Vieille Baderne|Bécasse|Demi-Sel|Pouffe|Rastaquouère|Triple Buse|Peau De Bite|Roublard|Ahuri|Voyou|Radin|Gueule De Raie|Zigoto|Canaillou|Tapin|Niais|Niaiseux|Grave|Syphonné|Louf|Toqué|Sinoque|Fesse De Moule|Bourrin|Saleté|Pourceau|Crisss|Sacrement|Brigand|Emmerdeur|Sac A Brin|Enfant De Tainpu|Gueudin|Gredin|Estupido|Graveleux|Gnome|Bordel|Bordel à Cul|Casse-pieds|Ignare|Bouricot|Illettré|Miteux|Vipère Lubrique|Foldingue|Sacrebleu|Parbleu|Ventrebleu|Tudieu|Cornegidouille|Saperlipopette|Sac à Gnole|Serpillière à Foutre|Chiante|Diantre|Fichtre|Foutre|Malandrin|Flûte|Malapris|Goliot|Peau De Couille|Cruche|Fouchtra|Maritorne|Chabraque|Gaupe|Harpie|Hétaïre|Pie-grièche|Mijaurée|Péronelle|Poissarde|Rombière|Virago|Croquignolet|Gueule D'empeigne|Culbuto|Bidochon|Beauf|Bulot|Traîne-savate|Pousse-crotte|Tronche En Biais|Galopin|Nazebroque|Chemo|Gomorrhite|Dinde|Ventre Saint Gris|Pédés|Guenon|Clocharde|Relou|Cacou|Bougresse|Tas D'cons|Indécrotable|Bélître|Pédozoonécrophile|Faux Cul|Alburostre|Alvéopyge|Ambisenestre|Antirotodongyrateur|Archéodendrite|Aspermogène|Bovinoderme|Cacoglotte|Coprolithe|Coprolupanar|Géopyge|Hyperthyrroïdien Des Alpes|Latérograde|Micromyxeux|Nanipabullophile|Nodocéphale|Oculogynécomane|Ostréipyge|Orchidoclaste|Ovocéphale|Paléocapridé|Paléotalpidé|Phallosophe|Phyllotétanique|Podoclaste|Pseudopyge|Pyropyge|Stratocumulocéphale|Suprapygoflatulent|Zoocopulatoire|Kurac [ Bite En Bosniaque]|Stéatopyge|Chagasse|Baudet|Maroufle|Frappé|Frappadingue|Puceau|Grippe-sous|Sainte Nitouche|Marie-couche-toi-là|Tartuffe|Ostie De Tabarnak|Menteur|égoiste|Diable|Puterelle|Ribaude|Casse-couilles|Benêt|Inculte|Dégueulasse".split("|");

        let mybus_preinscription = {

            // Current and max step
            step: 0,
            maxStep: 0,

            // Number of key press on cities
            citiesKeyPress: 0,

            // City datas
            current_city: null,
            current_zipcode: null,
            current_enable: null,

            // Offset top contact img
            contactImgOffsetTop: 170,

            // Campaign tracker
            tracker_android: "&utm_campaign=website&utm_source=website&utm_medium=website&utm_term=init&utm_content=init",

            init: function () {

                // Check if init is needed
                if ($('body.page-template-preinscription').length) {

                    // Init step
                    mybus_preinscription.initStep();

                    // Init cities autocomplete
                    //mybus_preinscription.citiesAutocomplete();

                    // Bind next step
                    mybus_preinscription.nextStep();

                    // Bind input name
                    mybus_preinscription.bindNameInput();

                    // Init vote button
                    mybus_preinscription.initVote();

                }

                // Init popover
                mybus_preinscription.initPopover();

                // Init tracking
                mybus_preinscription.initTracking();
            },

            // Init popover
            initPopover: function () {
                // Init popover
                $('a.pop').webuiPopover({
                    title: mybusjs.trad_downloadAppli,
                    trigger: 'hover'
                });

                $(document).on('click', 'a.pop', function (e) {
                    e.preventDefault();
                });

                $('.store_link.android').each(function () {
                    let href = $(this).attr('href') + mybus_preinscription.tracker_android;
                    $(this).attr('href', href);
                });

                // Search input
                $(document).on('keyup', '#search_apple, #search_android', function () {
                    // Get id
                    let id = $(this).attr('id');

                    // Search
                    let search = $(this).val().toLowerCase();

                    // Empty ?
                    if (!$(this).val()) {
                        $('[rel="' + id + '"]').show();
                    } else {
                        $('[rel="' + id + '"]').each(function () {
                            let value = $('a', this).html().toLowerCase();

                            if (value.indexOf(search) != -1) {
                                $(this).show();
                            } else {
                                $(this).hide();
                            }
                        });
                    }
                });
            },

            // Init tracking
            initTracking: function () {

                // Adapt top menu
                $('#site-header-nav li.menu-item a').each(function () {
                    if ($(this).html() == "Les villes") {
                        $(this).addClass('ga_event')
                            .data('category', 'Home')
                            .data('action', 'click')
                            .data('label', 'Lien : Les villes')
                            .data('value', '157');
                    }
                    if ($(this).html() == "Pré-inscription") {
                        $(this).addClass('ga_event')
                            .data('category', 'Home')
                            .data('action', 'click')
                            .data('label', 'Preinscription : Pré-inscription')
                            .data('value', '251');
                    }
                });

                // Bind links
                $(document).on('click', 'a.ga_event', function (e) {

                });
            },

            // Init step
            initStep: function () {
                // Set global variable
                mybus_preinscription.step = 1;

                // Set animation
                mybus_preinscription._doAnimation();

                window.setTimeout(function () {
                    $('html, body').scrollTop(0);
                }, 2000);

                $('.contact-img .contact-bus').fadeTo(800, 1, function () {
                    $('.contact-img .contact-stop').fadeTo(800, 1);
                });
            },

            _doAnimation: function () {
                // Set step
                let step = 1;
                if ($('.step1').is(':visible')) {
                    step = 2;
                }
                if ($('.step2').is(':visible')) {
                    step = 3;
                }
                if ($('.step3-1').is(':visible') || $('.step3-2').is(':visible')) {
                    $('.step3-1, .step3-2').hide();
                    step = 4;
                }

                // Set max step
                if (mybus_preinscription.maxStep < mybus_preinscription.step) {
                    mybus_preinscription.maxStep = mybus_preinscription.step;
                }

                // Set scenario
                if (step == 2) {
                    if (!mybus_preinscription._verifStep1()) {
                        return false;
                    }
                } else if (step >= 3) {

                    if (!mybus_preinscription._verifStep2() || !mybus_preinscription._verifStep1()) {
                        return false;
                    }
                }

                if (step >= 3) {
                    $('.step3-2, .step3-1').hide();
                    if (mybus_preinscription.current_enable) {
                        step = "3-1";
                    } else {
                        step = "3-2";
                    }
                    $('#step3_error').removeClass('good');

                    // Display final message
                    if (step == '3-1') {
                        $('#ins_final_message').addClass('is-active');
                    } else {
                        $('#ins_final_message').removeClass('is-active');
                    }

                }

                // Hide buttons
                $('#ins_next').hide();
                $('#ins_vote').hide();

                // Display boxes
                if ($('.bus.step' + step).length) {

                    // Hide next div
                    $('.bus.step' + step).nextAll().each(function () {
                        if ($(this).hasClass('user') || $(this).hasClass('bus') || $(this).hasClass('error')) {
                            $(this).slideUp();
                        }
                    });

                    $('.bus.step' + step).slideDown().fadeTo(800, 1, function () {
                        // Scroll
                        if (parseInt(step, 10) > 1) {
                            $('html, body').animate({
                                scrollTop: $('.bus.step' + step).offset().top - mybus_preinscription.contactImgOffsetTop
                            }, 1500);
                        }

                        // Show user box
                        if ($('.user.step' + step).length) {
                            $('.user.step' + step).slideDown().fadeTo(800, 1, function () {
                                // Focus on input
                                if ($('.user.step' + step + ' input').length) {
                                    $('.user.step' + step + ' input').focus().val('');
                                }

                                // Show button
                                if (step != "3-1") {

                                    if (step != "3-2") {
                                        $('#ins_next').fadeIn('slow');
                                    } else {
                                        $('#ins_vote').fadeIn('slow');
                                    }
                                }

                            });
                        }

                    });
                }
            },

            // Manage next step clic
            nextStep: function () {
                $(document).on('click', '#ins_next', function (e) {
                    e.preventDefault();
                    mybus_preinscription._doAnimation();
                });
            },

            // Validator for step 1
            _verifStep1: function () {
                // Init
                let valid = true;

                // Check empty
                if ($('#ins_name').val().trim().length < 2) {
                    $('.step1_error').html(mybusjs.trad_timide);
                    valid = false;
                }

                // Check number in name !!
                let matches = $('#ins_name').val().match(/\d+/g);
                if (matches != null) {
                    $('.step1_error').html(mybusjs.trad_espion);
                    valid = false;
                }

                // Check insults
                let value = $('#ins_name').val().toLowerCase();
                for (let i in insults.split('|')) {
                    let insult = insults.split('|')[i];
                    if (value == insult.toLowerCase()) {
                        $('.step1_error').html(mybusjs.trad_insult);
                        valid = false;
                    }
                }

                // Return
                if (!valid) {
                    $('.step1_error').show();
                } else {
                    $('.step1_error').hide();
                }

                return valid;
            },

            // Validator for step 2
            _verifStep2: function () {
                mybus_preinscription._verifStep1();

                // Init
                let valid = true;

                // Check insults
                if (mybus_preinscription.current_city == null) {
                    $('.step2_error').html(mybusjs.trad_selection_ville);
                    valid = false;
                }

                // Check empty
                if ($('#ins_city').val() == '') {
                    $('.step2_error').html(mybusjs.trad_aucune_ville);
                    valid = false;
                }

                // Return
                if (!valid) {
                    $('.step2_error').show();
                } else {
                    $('.step2_error').hide();
                }

                return valid;
            },

            // Check email
            validateEmail: function (email) {

                // Check email
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let checkMail = re.test(email);

                if (checkMail) {
                    return true;
                }

                // Accept phone too
                let rePhone = /^((0|\\+33|0033)[1-9][0-9]{8})$/;
                let checkPhone = rePhone.test(email);

                if (checkPhone) {
                    return true;
                }

                return false;
            },

            // Init vote button
            initVote: function () {
                // Bind click
                $(document).on('click', '#ins_vote', function (e) {
                    e.preventDefault();

                    // Validator
                    let email = $('#ins_email').val().replace(/ /g, '');
                    if (!mybus_preinscription.validateEmail(email)) {
                        $('.step3_error').html(mybusjs.trad_mauvais_email).show();
                        return false;
                    }

                    // Check loading
                    if ($(this).hasClass('loading') || $(this).hasClass('done')) {
                        if ($(this).hasClass('done')) {
                            $('.step3_error').html(mybusjs.trad_deja_vote).show();
                            $('#ins_vote').hide();
                        }
                        return false;
                    }

                    // Set loader
                    $(this).addClass('loading').html('<i class="fa fa-refresh fa-spin"></i>');

                    // Call web service
                    $.ajax({
                        method: "POST",
                        url: mybusjs.ajaxurl,
                        dataType: "json",
                        data: {
                            action: "send_city_vote",
                            email: email,
                            name: $('#ins_name').val(),
                            city: mybus_preinscription.current_city,
                            zipcode: mybus_preinscription.current_zipcode
                        }
                    })
                        .done(function (response) {
                            // Check error
                            if (response.error) {
                                $('.step3_error').html(response.msg).removeClass('good').show();

                            } else {
                                $('.step3_error').html(response.msg).addClass('good').show();
                                $('#ins_vote').fadeOut();

                            }

                        }).complete(function () {
                        $('#ins_vote').removeClass('loading').html('Voter');

                        // Display final message
                        $('#ins_final_message').addClass('is-active');
                    });

                    return false;
                })
            },

            // Manage name
            bindNameInput: function () {
                $(document).on('keyup', '#ins_name', function (e) {
                    // Enter key -> Next step
                    let code = e.keyCode || e.which;
                    if (code == 13) {
                        $('#ins_next').click();
                    }

                    $('#ins_user_name').html($('#ins_name').val());
                });

                $(document).on('blur', '#ins_name', function (e) {
                    $('#ins_user_name').html($('#ins_name').val());
                });

            },

            // Cities autocomplete
            citiesAutocomplete: function () {

                mybus_preinscription.citiesKeyPress = 0;
                $(document).on('keyup', '#ins_city', function (e) {

                    // Enter key -> Next step
                    let code = e.keyCode || e.which;

                    if (code == 13) {
                        $('#ins_next').click();
                    }

                    // Directional keys
                    if (code == 33) {
                    }

                    mybus_preinscription.citiesKeyPress++;

                    setTimeout(function () {
                        mybus_preinscription.citiesKeyPress--;

                        if (mybus_preinscription.citiesKeyPress == 0) {

                            $.ajax({
                                method: "POST",
                                url: mybusjs.ajaxurl,
                                dataType: "json",
                                data: {ville: encodeURIComponent($('#ins_city').val()), action: "cities"}
                            })

                                .done(function (cities) {

                                    // Reset autocomplete
                                    $('#mybus_villes_autocomplete').html('');

                                    // Display cities
                                    for (var i in cities) {
                                        var city = cities[i];
                                        var html = '<span href="#todo" class="city-name">' + city.ville_nom_reel + ' (' + city.ville_code_postal.substring(
                                            0, 5) + ')</span>';
                                        var newDiv = $('<li>').addClass('autocomplete').html(html);
                                        var myBusEnable = 0;
                                        if (city.organisme_gestion != undefined) {
                                            myBusEnable = 1;
                                        }
                                        newDiv.attr('data-city', city.ville_nom_reel)
                                            .attr('data-mybus', myBusEnable)
                                            .attr('data-android', city.lien_android + mybus_preinscription.tracker_android)
                                            .attr('data-organism', city.organisme_gestion)
                                            .attr('data-apple', city.lien_apple)
                                            .attr('data-zipcode', city.ville_code_postal.substring(0, 5));
                                        $('#mybus_villes_autocomplete').append(newDiv);
                                    }

                                });
                        }
                    }, 300);

                });

                // Bind clic on city
                $(document).on('click', '#mybus_villes_autocomplete li', function (e) {

                    // Get datas
                    mybus_preinscription.current_city = $(this).data('city');
                    mybus_preinscription.current_enable = $(this).data('mybus');
                    mybus_preinscription.current_zipcode = $(this).data('zipcode');

                    // Update store link
                    $('#ins_android').attr('href', $(this).data('android'))
                        .data('label', 'Android : ' + $(this).data('organism'));
                    $('#ins_apple').attr('href', $(this).data('apple'))
                        .data('label', 'Apple : ' + $(this).data('organism'));

                    // Update input and fields
                    $('#ins_city').val(mybus_preinscription.current_city + ' (' + mybus_preinscription.current_zipcode + ')');
                    $('span.city').html(mybus_preinscription.current_city);

                    // Clear result
                    $('#mybus_villes_autocomplete').html('');

                    // Next step
                    mybus_preinscription._doAnimation();

                    // Hide error
                    $('.step2_error').hide();
                });
            }

        };

        mybus_preinscription.init();

        /* Page preinscription
        /* ============================================= */
        if ($('body.page-template-preinscription').length) {
        }
    }

}